
export enum InvoiceCategoryConstants {
    invoice = 1,
    cancellation = 2
}

export const InvoiceCategoryDisplayNames = {
    InvoiceCategoryDisplayNameInvoice: $localize`Rechnung`,
    InvoiceCategoryDisplayNameCancellation: $localize`Stornorechnung`,
}

export class InvoiceCategory {
    public Id: number;
    public DisplayName: string;
}
